"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useOnChangeFile_1 = __importDefault(require("./hooks/useOnChangeFile"));
var useStyles_1 = __importDefault(require("./useStyles"));
var Input = function (props) {
    var id = props.id, accept = props.accept, onChange = props.onChange, setFileName = props.setFileName, inputRef = props.inputRef, label = props.label, multiple = props.multiple;
    var classes = (0, useStyles_1.default)();
    var onChangeFile = (0, useOnChangeFile_1.default)(setFileName, onChange, accept);
    return (react_1.default.createElement("input", { id: id, type: "file", accept: accept, onChange: onChangeFile, ref: inputRef, className: classes.input, placeholder: label, multiple: multiple }));
};
exports.default = Input;
